import { render, staticRenderFns } from "./OnlineOrderCategorySelects.vue?vue&type=template&id=09681de4&"
import script from "./OnlineOrderCategorySelects.vue?vue&type=script&lang=js&"
export * from "./OnlineOrderCategorySelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports